export const User_Signup_Request = 'User_Signup_Request'
export const User_Signup_Success = 'User_Signup_Success'
export const User_Signup_Failure = 'User_Signup_Failure'

export const User_Login_Request = 'User_Login_Request'
export const User_Login_Success = 'User_Login_Success'
export const User_Login_Failure = 'User_Login_Failure'

export const All_Users_Request = 'All_Users_Request'
export const All_Users_Success = 'All_Users_Success'
export const All_Users_Failure = 'All_Users_Failure'

export const Open_Group_Request = 'Open_Group_Request'
export const Open_Group_Success = 'Open_Group_Success'
export const Open_Group_Failure = 'Open_Group_Failure'

export const All_Friends_Request = 'All_Friends_Request'
export const All_Friends_Success = 'All_Friends_Success'
export const All_Friends_Failure = 'All_Friends_Failure'

export const Load_Chat_Request = 'Load_Chat_Request'
export const Load_Chat_Success = 'Load_Chat_Success'
export const Load_Chat_Failure = 'Load_Chat_Failure'

export const New_Chat_Request = 'New_Chat_Request'
export const New_Chat_Success = 'New_Chat_Success'
export const New_Chat_Failure = 'New_Chat_Failure'

export const Search_Users_Request = 'Search_Users_Request'
export const Search_Users_Success = 'Search_Users_Success'
export const Search_Users_Failure = 'Search_Users_Failure'

export const Close_Search = 'Close_Search'

export const Make_Group = 'Make_Group'
export const Close_Group = 'Close_Group'

export const Create_Group_Request = 'Create_Group_Request'
export const Create_Group_Success = 'Create_Group_Success'
export const Create_Group_Failure = 'Create_Group_Failure'

export const Close_Chat = 'Close_Chat'

export const View_Chat_Success = 'View_Chat_Success'
export const View_Chat_Failure = 'View_Chat_Failure'

export const Typing = "Typing"

export const Stop_Typing = "Stop_Typing"

export const Sort_Groups = "Sort_Groups"

export const Received_Offer  = 'Received_Offer'

export const Store_Peer = "Store_Peer"

export const Received_Answer = 'Received_Answer'

export const Call_Rejected = 'Call_Rejected'

export const ICE_Candidate_Received = 'ICE_Candidate_Received'

export const Make__Call = 'Make__Call'

export const Make__Incoming = 'Make__Incoming'

export const Store_Candidate = "Store_Candidate"

export const Clear_Offer = "Clear_Offer"
export const Audio_Only = 'Audio_Only'

export const Make_Group_Call = 'Make_Group_Call'

export const Make_Group_Incoming = 'Make_Group_Incoming'

export const Save_Room = 'Save_Room'

export const Change_Photo_Request = 'Change_Photo_Request'
export const Change_Photo_Success = 'Change_Photo_Success'
export const Change_Photo_Failure = 'Change_Photo_Failure'

export const Delete_Photo_Request = 'Delete_Photo_Request'
export const Delete_Photo_Success = 'Delete_Photo_Success'
export const Delete_Photo_Failure = 'Delete_Photo_Failure'

export const Logout = 'Logout'

export const Change_GroupPhoto_Request = 'Change_GroupPhoto_Request'
export const Change_GroupPhoto_Success = 'Change_GroupPhoto_Success'
export const Change_GroupPhoto_Failure = 'Change_GroupPhoto_Failure'

export const Leave_Group_Request = 'Leave_Group_Request'
export const Leave_Group_Success = 'Leave_Group_Success'
export const Leave_Group_Failure = 'Leave_Group_Failure'

export const Make_Admin_Request = 'Make_Admin_Request'
export const Make_Admin_Success = 'Make_Admin_Success'
export const Make_Admin_Failure = 'Make_Admin_Failure'

export const New_Admin = "New_Admin"

export const Updated_Group = "Updated_Group"

export const New_Group_Created = "New_Group_Created"

export const Removed_From_Group = "Removed_From_Group"

export const Set_Description_Request = 'Set_Description_Request'
export const Set_Description_Success = 'Set_Description_Success'
export const Set_Description_Failure = 'Set_Description_Failure'

export const Set_AboutMe_Request = 'Set_AboutMe_Request'
export const Set_AboutMe_Success = 'Set_AboutMe_Success'
export const Set_AboutMe_Failure = 'Set_AboutMe_Failure'

export const Get_User_Request = 'Get_User_Request'
export const Get_User_Success = 'Get_User_Success'
export const Get_User_Failure = 'Get_User_Failure'

export const Get_Languages_Request = 'Get_Languages_Request'
export const Get_Languages_Success = 'Get_Languages_Success'
export const Get_Languages_Failure = 'Get_Languages_Failure'

export const Translate_Text_Request = 'Translate_Text_Request'
export const Translate_Text_Success = 'Translate_Text_Success'
export const Translate_Text_Failure = 'Translate_Text_Failure'

export const Change_Theme = 'Change_Theme'

export const Delete_ForMe_Request = 'Delete_ForMe_Request'
export const Delete_ForMe_Success = 'Delete_ForMe_Success'
export const Delete_ForMe_Failure = 'Delete_ForMe_Failure'

export const Delete_ForAll_Request = 'Delete_ForAll_Request'
export const Delete_ForAll_Success = 'Delete_ForAll_Success'
export const Delete_ForAll_Failure = 'Delete_ForAll_Failure'

export const Translation_Box_Close = "Translation_Box_Close"

export const Get_Latest_Chat = 'Get_Latest_Chat'

export const End_Group_Call = 'End_Group_Call'

export const Audio_GroupCall = 'Audio_GroupCall'

export const Set_Call_Receiver = 'Set_Call_Receiver'
export const SET_SIDEBAR_TAB = 'SET_SIDEBAR_TAB'
